export default __webpack_public_path__ + "static/media/img-50.da5a3e32.jpg";